import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title id="Cart">{props.title || 'Cart'}</title>
      <g>
        <path d="M440.2 328.3c-3.5 13.9-15.7 23.8-30.2 23.8h-250.2c-14.5 0-27.3-9.9-30.2-23.8l-63.9-258.4h-31.3c-17.5 0-31.4-14-31.4-31.4s13.9-31.3 31.4-31.3h55.7c14.5 0 27.3 9.9 30.8 23.8l17.4 70.3h355.9c2.9 0 6.4 1.7 8.1 4.1 2.3 2.3 2.9 5.8 1.8 8.7l-63.9 214.2zm-238.6 76c29 0 52.2 23.2 52.2 52.3 0 29-23.2 52.2-52.2 52.2s-52.3-23.2-52.3-52.2 23.3-52.3 52.3-52.3zm167.2 0c29 0 52.2 23.2 52.2 52.3 0 29-23.2 52.2-52.2 52.2s-52.3-23.2-52.3-52.2 23.3-52.3 52.3-52.3z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/cart.js